module.exports = __webpack_public_path__ + "img/book-images-R.a9f9c5fa.png";